import { useEffect, useRef } from "react";
import { createAppSocket } from '../api/createAppSocket';

export default function useAgentPresenceSocket(onPresencePatch) {
  const socketRef = useRef(null);
  const patchRef = useRef(onPresencePatch);
  patchRef.current = onPresencePatch;

  useEffect(() => {
    socketRef.current = createAppSocket();

    const patchRow = (agentId, updater) => {
      patchRef.current?.(agentId, updater);
    };

    const handleUpdateChatStatus = (agentId, status) => {
      patchRow(agentId, () => ({
        presence: status ? "accepting" : "notAccepting",
      }));
    };

    const handleLogin = (agentId) => {
      patchRow(agentId, () => ({ presence: "accepting" }));
    };

    const handleLogout = (agentId) => {
      patchRow(agentId, () => ({ presence: "offline" }));
    };

    socketRef.current.on("get-status", handleUpdateChatStatus);
    socketRef.current.on("check-login", handleLogin);
    socketRef.current.on("check-single-logout", handleLogout);
    socketRef.current.on("check-logout", handleLogout);

    return () => {
      socketRef.current?.off("get-status", handleUpdateChatStatus);
      socketRef.current?.off("check-login", handleLogin);
      socketRef.current?.off("check-single-logout", handleLogout);
      socketRef.current?.off("check-logout", handleLogout);
    };
  }, []);

  return socketRef;
}
